import Axios from '../lib/axios'

class LovService {

  async all (lovType, deleted) {
      const result = await Axios.authenticated().get(`/lov`, {
          params: {
            type: lovType,
            deleted: deleted
          }
      })
      return result
  }
    
  async create (lov) {
    const result = await Axios.authenticated().post(
      `/lov`,
      lov
    )
    return result
  }

  async update (lov) {
    const result = await Axios.authenticated().put(`/lov`, lov)
    return result
  }

  async updateOrder (lovs) {
    const result = await Axios.authenticated().put(`/lov/order`, lovs)
    return result
  }
}

export default new LovService()
